import { dateString2BPMSFormat } from "../utils/dateString2BPMSFormat";

function payloadAdapter(data: any) {
    const payLoad = {
        formName: "form_fosfec",
        requireValidation: false,
        responses: [
            {
                answer: data.neighborhood,
                idQuestion: "neighborhood",
            },
            {
                answer: data.statusJob,
                idQuestion: "statusJob",
            },
            {
                answer: data.currentPension,
                idQuestion: "currentPension",
            },
            {
                answer: data.hasReceivedOutgoingsBenefit,
                idQuestion: "hasReceivedOutgoingsBenefit",
            },
            {
                answer: dateString2BPMSFormat(data.dateSubsideUnemployment),
                idQuestion : "dateSubsideUnemployment"
            },
            {
                answer: dateString2BPMSFormat(data.laborTermination),
                idQuestion: "laborTermination",
            },
            {
                answer: data.interest,
                idQuestion: "interest",
            },
            {
                answer: data.enterpriseName,
                idQuestion: "enterpriseName",
            },
            {
                answer: data.appModality,
                idQuestion: "appModality",
            },
            {
                answer: data.employmentStatus,
                idQuestion: "employmentStatus",
            },
            {
                answer: dateString2BPMSFormat(data.expeditionDate),
                idQuestion: "expeditionDate",
            },
            {
                answer: data.zone,
                idQuestion: "zone",
            },
            {
                answer: data.ethnic,
                idQuestion: "ethnic",
            },
            {
                answer: data.haveDisability,
                idQuestion: "haveDisability",
            },
            {
                answer: data.discapacityCondition,
                idQuestion : "discapacityCondition"
            },
            {
                answer: data.indicateReservation,
                idQuestion: "indicateReservation",
            },
            {
                answer: data.indigenousTown,
                idQuestion: "indigenousTown",
            },
            {
                answer: data.population,
                idQuestion: "population",
            },
            {
                answer: data.vulnerabilityFactor,
                idQuestion: "vulnerabilityFactor",
            },
            {
                answer: data.healthCareProvider,
                idQuestion: "healthCareProvider",
            },
            {
                answer: data.isAfiliatedPensionFund,
                idQuestion: "isAfiliatedPensionFund",
            },
            {
                answer: data.pensionFundAfiliate,
                idQuestion: "pensionFundAfiliate",
            },
            {
                answer: data.noPensionPayed,
                idQuestion: "noPensionPayed",
            },
            {
                answer: data.saveForLayoffsFund,
                idQuestion: "saveForLayoffsFund",
            },
            {
                answer: data.afiliationLayoffsFund,
                idQuestion: "afiliationLayoffsFund",
            },
            {
                answer: data.hasBeenMembershipedFoundCompensation,
                idQuestion: "hasBeenMembershipedFoundCompensation",
            },
            {
                answer: data.otherCompensationFund0,
                idQuestion: "otherCompensationFund0",
            },
            {
                answer: data.otherCompensationFund1,
                idQuestion: "otherCompensationFund1",
            },
            {
                answer: data.compensationFund,
                idQuestion: "compensationFund",
            },
            {
                answer: data.afiliatedMonths0,
                idQuestion: "afiliatedMonths0",
            },
            {
                answer: data.afiliatedMonths1,
                idQuestion: "afiliatedMonths1",
            },
            {
              answer:`[{"_id": 1686756832817,"caja_compensacion": "${data.otherCompensationFund0}","meses_afiliados": ${data.afiliatedMonths0}}${data.otherCompensationFund1 && `,{"_id": 1686756832817,"caja_compensacion": "${data.otherCompensationFund1}","meses_afiliados": ${data.afiliatedMonths1}}`} ]`,
              idQuestion: "otherWelfares",
            },
            {
                answer: data.lastSalary,
                idQuestion: "lastSalary",
            },
            {
                answer: data.accountType,
                idQuestion: "accountType",
            },
            {
                answer: data.financialEntity,
                idQuestion: "financialEntity",
            },
            {
                answer: data.accountNumber,
                idQuestion: "accountNumber",
            },
            {
                answer: data.laborRelationship,
                idQuestion: "laborRelationship",
            },
            {
                answer: data.acceptedDeclaration,
                idQuestion: "acceptedDeclaration",
            },
            {
                answer: data.acceptedTreatmentData,
                idQuestion: "acceptedTreatmentData",
            },
            {
                answer: data.independentType,
                idQuestion: "independentType",
            },
            {
                answer: data.educationLevel,
                idQuestion: "educationLevel",
            },
            {
                answer: data.department,
                idQuestion: "department",
            },
            {
                answer: data.laborDepartment,
                idQuestion: "laborDepartment",
            },
            {
                answer: data.city,
                idQuestion: "city",
            },
            {
                answer: data.publicServiceLaborCertificateFile,
                idQuestion: "publicServiceLaborCertificateFile",
            },
            {
                answer: data.finishedLaborCertificateFile,
                idQuestion: "finishedLaborCertificateFile",
            },
            {
                answer: data.idDocumentFile,
                idQuestion: "idDocumentFile",
            },
            {
                answer: data.idFormBPMS,
                idQuestion: "idFormBPMS",
            },
            {
                answer: data.proccessIdBPMS,
                idQuestion: "proccessIdBPMS",
            },
            {
                answer: data.bp,
                idQuestion: "bp"
            }
        ],
        user: {
            address: data.address,
            city: data.city,
            idNum: data.idNum,
            idNumType: data.idNumType,
            email: data.email,
            firstName: (data.firstName + " " + data.secondName).trim(),
            lastName: (data.lastName + " " + data.secondLastName).trim(),
            cellphone: data.cellPhoneNumber,
            phone: data.phone,
            gender: data.gender,
            dateOfBirth: data.dateOfBirth,
        },
    };
    //if the noFundPayedDocumentFile is added we're going to push it into payload Json
    if(data.noFundPayedDocumentFile){
        payLoad.responses.push( {
            answer: data.noFundPayedDocumentFile,
            idQuestion: "noFundPayedDocumentFile",
    })
    }

    return payLoad;
}

export default payloadAdapter;
